<div  (click)="go()" class="box-dashboard">
    <img style="margin:auto;" mat-card-image src="../../../../assets/{{image}}">
    <div class="title-box">{{title}}</div>
</div>